/* Mr Pixel — blog post sidebars. */
(function () {
  'use strict';

  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    if (!base) base = 'section';

    var slug = base;
    var n = 2;
    while (used[slug]) {
      slug = base + '-' + n;
      n += 1;
    }
    used[slug] = true;
    return slug;
  }

  function buildToc(content, toc) {
    var list = toc.querySelector('#mp-toc-list');
    if (!list) return null;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      toc.remove();
      return null;
    }

    var used = {};
    var entries = [];

    headings.forEach(function (heading) {
      if (heading.id) {
        used[heading.id] = true;
      } else {
        heading.id = 'mp-toc-' + slugify(heading.textContent, used);
      }

      var li = document.createElement('li');
      li.className = 'mp-toc__item mp-toc__item--' + heading.tagName.toLowerCase();

      var a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      a.dataset.mpTocTarget = heading.id;

      li.appendChild(a);
      list.appendChild(li);
      entries.push({ heading: heading, link: a });
    });

    return entries;
  }

  function watchScrollspy(entries) {
    if (!('IntersectionObserver' in window) || !entries.length) return;

    var current = null;

    function setActive(id) {
      if (id === current) return;
      current = id;
      entries.forEach(function (entry) {
        entry.link.classList.toggle('is-active', entry.heading.id === id);
      });
    }

    var observer = new IntersectionObserver(
      function (observerEntries) {
        observerEntries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    entries.forEach(function (entry) {
      observer.observe(entry.heading);
    });

    setActive(entries[0].heading.id);
  }

  function wireSmoothScroll(toc) {
    toc.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-mp-toc-target]');
      if (!link) return;

      var target = document.getElementById(link.dataset.mpTocTarget);
      if (!target) return;

      event.preventDefault();
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + target.id);
    });
  }

  function wireProgressBar(content) {
    var bar = document.getElementById('mp-progress-bar');
    if (!bar) return;
    var fill = bar.querySelector('.mp-progress-bar__fill');
    if (!fill) return;

    var ticking = false;

    function update() {
      ticking = false;
      var top = content.getBoundingClientRect().top + window.scrollY;
      var scrollable = content.offsetHeight - window.innerHeight;

      var progress = scrollable > 0 ? (window.scrollY - top) / scrollable : 1;
      progress = Math.min(1, Math.max(0, progress));
      fill.style.transform = 'scaleX(' + progress + ')';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    var content = document.querySelector('.mp-article-layout__content');
    if (!content) return;

    wireProgressBar(content);

    var toc = document.getElementById('mp-toc');
    if (!toc) return;

    var entries = buildToc(content, toc);
    if (!entries) return;

    watchScrollspy(entries);
    wireSmoothScroll(toc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
